import fr from './locales/fr';
import ar from './locales/ar';

const translations = { fr, ar };

/**
 * Get a nested translation value by dot-notation key.
 * Example: getTranslation('fr', 'navbar.dashboard') => "Tableau de bord"
 */
export function getTranslation(locale, key) {
  const keys = key.split('.');
  let result = translations[locale];
  
  for (const k of keys) {
    if (result === undefined || result === null) return key;
    result = result[k];
  }
  
  return result !== undefined && result !== null ? result : key;
}

/**
 * Create a translator function bound to a specific locale.
 * Usage: const t = createTranslator('ar'); t('navbar.dashboard')
 */
export function createTranslator(locale) {
  return (key, fallback) => {
    const value = getTranslation(locale, key);

    if (value !== key) {
      // Key found in translation file — interpolate {variables} if fallback is a params object
      if (typeof fallback === 'object' && fallback !== null) {
        return value.replace(/\{(\w+)\}/g, (match, varName) =>
          fallback[varName] !== undefined ? fallback[varName] : match,
        );
      }
      return value;
    }

    // Key not found — return string fallback, or the key itself (prevents returning objects)
    return typeof fallback === 'string' ? fallback : value;
  };
}

export const supportedLocales = [
  { code: 'fr', name: 'Français', flag: '🇫🇷', dir: 'ltr' },
  { code: 'ar', name: 'العربية', flag: '🇲🇦', dir: 'rtl' },
];

export const defaultLocale = 'fr';

export { translations };
